"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateComponent = validateComponent;
exports.validateComponentEvents = validateComponentEvents;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@testing-library/react");
var _userEvent = _interopRequireDefault(require("@testing-library/user-event"));
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); } /* eslint-disable import/no-extraneous-dependencies */
var customTestId = 'custom-test-id';

/**
 * Validates a component's test IDs and inner elements rendering
 *
 * @example
 * ```tsx
 * // Basic usage with default test ID
 * validateComponent({
 *   Component: Button,
 *   props: { children: 'Click me' },
 *   defaultTestId: 'button'
 * });
 *
 * // Testing inner elements
 * validateComponent({
 *   Component: ListItem,
 *   props: {
 *     prefix: <Icon />,
 *     suffix: <Icon />,
 *     children: 'List Item'
 *   },
 *   defaultTestId: 'list-item',
 *   innerElements: ['prefix', 'suffix']
 * });
 *
 * // Skip custom test ID validation
 * validateComponent({
 *   Component: Text,
 *   props: { children: 'Hello' },
 *   defaultTestId: 'text',
 *   skipCustomTestId: true
 * });
 * ```
 *
 * // Custom disabled attribute
 * validateComponent({
 *   Component: Button,
 *   props: { children: 'Click me' },
 *   defaultTestId: 'button',
 *   disabledAttribute: 'aria-disabled'
 * });
 */
function validateComponent(config) {
  var Component = config.Component,
    props = config.props,
    _config$defaultTestId = config.defaultTestId,
    defaultTestId = _config$defaultTestId === void 0 ? 'component' : _config$defaultTestId,
    _config$innerElements = config.innerElements,
    innerElements = _config$innerElements === void 0 ? [] : _config$innerElements,
    _config$skipCustomTes = config.skipCustomTestId,
    skipCustomTestId = _config$skipCustomTes === void 0 ? false : _config$skipCustomTes,
    _config$skipForwardRe = config.skipForwardRef,
    skipForwardRef = _config$skipForwardRe === void 0 ? false : _config$skipForwardRe,
    _config$disabledAttri = config.disabledAttribute,
    disabledAttribute = _config$disabledAttri === void 0 ? 'data-disabled' : _config$disabledAttri;
  describe('Component validation', function () {
    describe('Test IDs', function () {
      it('should render with default test ID', function () {
        (0, _react2.render)(/*#__PURE__*/_react["default"].createElement(Component, props));
        expect(_react2.screen.getByTestId(defaultTestId)).toBeInTheDocument();
      });
      if (!skipCustomTestId) {
        it('should render with custom test ID', function () {
          (0, _react2.render)(/*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({}, props, {
            "data-testid": customTestId
          })));
          expect(_react2.screen.getByTestId(customTestId)).toBeInTheDocument();
        });
      }
    });
    if (innerElements.length > 0) {
      describe('Inner elements', function () {
        if (defaultTestId) {
          innerElements.forEach(function (element) {
            it("should render ".concat(element, " element with default test ID"), function () {
              (0, _react2.render)(/*#__PURE__*/_react["default"].createElement(Component, props));
              var elementTestId = "".concat(defaultTestId, "-").concat(element);
              expect(_react2.screen.getByTestId(elementTestId)).toBeInTheDocument();
            });
          });
        }
        if (!skipCustomTestId) {
          innerElements.forEach(function (element) {
            it("should render ".concat(element, " element with custom test ID"), function () {
              (0, _react2.render)(/*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({}, props, {
                "data-testid": customTestId
              })));
              var elementTestId = "".concat(customTestId, "-").concat(element);
              expect(_react2.screen.getByTestId(elementTestId)).toBeInTheDocument();
            });
          });
        }
      });
    }
    if (!skipForwardRef) {
      describe('ForwaredRef', function () {
        it('should forward ref to the root element', function () {
          var ref = /*#__PURE__*/_react["default"].createRef();
          (0, _react2.render)(/*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({}, props, {
            ref: ref
          })));
          expect(ref.current).toBeInstanceOf(HTMLElement);
          expect(ref.current).toHaveAttribute('data-testid', defaultTestId !== null && defaultTestId !== void 0 ? defaultTestId : customTestId);
        });
      });
    }
    var hasDisabledProp = true;
    if (hasDisabledProp) {
      describe('Disabled state', function () {
        it('should be disabled when disabled prop is true', function () {
          (0, _react2.render)(/*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({}, props, !defaultTestId && {
            'data-testid': customTestId
          }, {
            disabled: true
          })));
          expect(_react2.screen.getByTestId(defaultTestId !== null && defaultTestId !== void 0 ? defaultTestId : customTestId)).toHaveAttribute(disabledAttribute);
        });
      });
    }
  });
}
/**
 * Validates a component's event handling behavior
 *
 * Tests the following interactions:
 * - Mouse click events
 * - Keyboard interactions (Enter and Space keys)
 * - Disabled state behavior
 *
 * The validation includes:
 * 1. Click interactions:
 *    - Mouse click triggers onClick
 *    - Enter key triggers onClick
 *    - Space key triggers onClick
 *
 * 2. Disabled state (if component has disabled/isDisabled prop):
 *    - Click does not trigger onClick
 *    - Enter key does not trigger onClick
 *    - Space key does not trigger onClick
 *
 * @example
 * ```tsx
 * // Basic onClick validation with all tests
 * validateComponentEvents({
 *   Component: Button,
 *   props: { children: 'Click me' },
 *   defaultTestId: 'button'
 * });
 *
 * // Customize onClick tests
 * validateComponentEvents({
 *   Component: Button,
 *   props: { children: 'Click me' },
 *   defaultTestId: 'button',
 *   onClickConfig: {
 *     skipEnter: true,    // Skip Enter key tests
 *     skipSpace: true,    // Skip Space key tests
 *   }
 * });
 * ```
 */
function validateComponentEvents(config) {
  var Component = config.Component,
    props = config.props,
    onClickConfig = config.onClickConfig,
    defaultTestId = config.defaultTestId;
  describe('Validate events', function () {
    var hasDisabledProp = true;
    var hasOnClickProp = true;
    if (hasOnClickProp && !(onClickConfig !== null && onClickConfig !== void 0 && onClickConfig.skip)) {
      describe('onClick', function () {
        it('onClick is called when clicked', function () {
          var onClick = jest.fn();
          (0, _react2.render)(/*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({}, props, !defaultTestId && {
            'data-testid': customTestId
          }, {
            onClick: onClick
          })));
          var component = _react2.screen.getByTestId(defaultTestId !== null && defaultTestId !== void 0 ? defaultTestId : customTestId);
          _react2.fireEvent.click(component);
          expect(onClick).toHaveBeenCalled();
        });
        if (!(onClickConfig !== null && onClickConfig !== void 0 && onClickConfig.skipEnter)) {
          it('onClick is called when Enter key is pressed', /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator().m(function _callee() {
            var onClick;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  onClick = jest.fn();
                  (0, _react2.render)(/*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({}, props, {
                    onClick: onClick
                  })));
                  // Tab to the component
                  _context.n = 1;
                  return _userEvent["default"].tab();
                case 1:
                  _context.n = 2;
                  return _userEvent["default"].keyboard('{Enter}');
                case 2:
                  expect(onClick).toHaveBeenCalled();
                case 3:
                  return _context.a(2);
              }
            }, _callee);
          })));
        }
        if (!(onClickConfig !== null && onClickConfig !== void 0 && onClickConfig.skipEnter)) {
          it('onClick is called when Space key is pressed', /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator().m(function _callee2() {
            var onClick;
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  onClick = jest.fn();
                  (0, _react2.render)(/*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({}, props, {
                    onClick: onClick
                  })));
                  // Tab to the component
                  _context2.n = 1;
                  return _userEvent["default"].tab();
                case 1:
                  _context2.n = 2;
                  return _userEvent["default"].keyboard(' ');
                case 2:
                  expect(onClick).toHaveBeenCalled();
                case 3:
                  return _context2.a(2);
              }
            }, _callee2);
          })));
        }
        if (hasDisabledProp) {
          describe('disabled state', function () {
            it('onClick is not called when clicked in disabled state', function () {
              var onClick = jest.fn();
              (0, _react2.render)(/*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({}, props, {
                onClick: onClick
              }, !defaultTestId && {
                'data-testid': customTestId
              }, {
                disabled: true
              })));
              var component = _react2.screen.getByTestId(defaultTestId !== null && defaultTestId !== void 0 ? defaultTestId : customTestId);
              _react2.fireEvent.click(component);
              expect(onClick).not.toHaveBeenCalled();
            });
            if (!(onClickConfig !== null && onClickConfig !== void 0 && onClickConfig.skipEnter)) {
              it('onClick is not called when Enter key is pressed in disabled state', /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator().m(function _callee3() {
                var onClick;
                return _regenerator().w(function (_context3) {
                  while (1) switch (_context3.n) {
                    case 0:
                      onClick = jest.fn();
                      (0, _react2.render)(/*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({}, props, {
                        onClick: onClick
                      }, !defaultTestId && {
                        'data-testid': customTestId
                      }, {
                        disabled: true
                      })));
                      // Tab to the component
                      _context3.n = 1;
                      return _userEvent["default"].tab();
                    case 1:
                      _context3.n = 2;
                      return _userEvent["default"].keyboard('{Enter}');
                    case 2:
                      expect(onClick).not.toHaveBeenCalled();
                    case 3:
                      return _context3.a(2);
                  }
                }, _callee3);
              })));
            }
            if (!(onClickConfig !== null && onClickConfig !== void 0 && onClickConfig.skipSpace)) {
              it('onClick is not called when Space key is pressed in disabled state', /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator().m(function _callee4() {
                var onClick;
                return _regenerator().w(function (_context4) {
                  while (1) switch (_context4.n) {
                    case 0:
                      onClick = jest.fn();
                      (0, _react2.render)(/*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({}, props, {
                        onClick: onClick
                      }, !defaultTestId && {
                        'data-testid': customTestId
                      }, {
                        disabled: true
                      })));
                      // Tab to the component
                      _context4.n = 1;
                      return _userEvent["default"].tab();
                    case 1:
                      _context4.n = 2;
                      return _userEvent["default"].keyboard(' ');
                    case 2:
                      expect(onClick).not.toHaveBeenCalled();
                    case 3:
                      return _context4.a(2);
                  }
                }, _callee4);
              })));
            }
          });
        }
      });
    }

    // TODO: add more events here
  });
}
//# sourceMappingURL=validate.js.map